module.exports = __webpack_public_path__ + "static/media/logo-100.3690435f.png";